import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18 4C18 6.20914 13.9706 8 9 8C4.02944 8 0 6.20914 0 4C0 1.79086 4.02944 0 9 0C13.9706 0 18 1.79086 18 4ZM0 12C0 14.2 4 16 9 16C9.42869 16 9.85003 15.9868 10.2621 15.9612C10.0911 16.6121 10 17.2954 10 18V19V19.9757C9.67186 19.9918 9.33822 20 9 20C4 20 0 18.2 0 16V12ZM18 10V6C18 8.2 14 10 9 10C4 10 0 8.2 0 6V10C0 12.2 4 14 9 14C9.73722 14 10.4527 13.9609 11.1368 13.8871C12.5354 11.5583 15.0857 10 18 10Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24 12V17H19L20.8304 15.1696C20.0904 14.4389 19.0798 14 18 14C15.7523 14 14 15.7523 14 18H12C12 14.6477 14.6477 12 18 12C19.6269 12 21.1399 12.6601 22.2446 13.7554L24 12ZM13.7602 22.2398L12 24V19H17L15.1758 20.8242C15.8526 21.559 16.8576 22 18 22C20.2477 22 22 20.2477 22 18H24C24 21.3523 21.3523 24 18 24C16.3655 24 14.8329 23.3701 13.7602 22.2398Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }